import React, { useEffect, useState } from 'react';
import '../App.css';
import axios from 'axios';
import { useLocation } from 'react-router-dom';
const VideoPlayer = () => {
    const [videoUrl, setVideoUrl] = useState('')
    const [videoType, setVideoType] = useState('');
    const location = useLocation();
    const searchParams = new URLSearchParams(location.search);
    const refno = searchParams.get('refno');
    useEffect(() => {
        const delayDebounceFn = setTimeout(() => {
            if (refno) {
                const config = {
                    method: "get",
                    url: `${process.env.REACT_APP_NODE_API_URL}/admin/fetch-video`,
                    params: { refno },
                    headers: {
                        accept: "application/json"
                    }
                };
    
                axios(config)
                    .then(res => {
                        if (res.data.video) {
                            setVideoUrl(res.data.video);
                        }
                    })
                    .catch(err => {
                        console.error("Failed to fetch video", err);
                    });
            }
        }, 500); // debounce delay (e.g., 500ms)
    
        return () => clearTimeout(delayDebounceFn); // cleanup previous timeout
    }, [refno]);
    useEffect(() => {
        const disableSelection = (e) => {
            if (typeof e.onselectstart !== 'undefined') {
                e.onselectstart = () => false;
            } else if (typeof e.style.MozUserSelect !== 'undefined') {
                e.style.MozUserSelect = 'none';
            } else {
                e.onmousedown = () => false;
            }
            e.style.cursor = 'default';
        };

        disableSelection(document.body);

        document.addEventListener('contextmenu', (e) => {
            if (e.target.nodeName !== 'A') e.preventDefault();
        });

        document.ondragstart = () => false;

        window.onkeydown = (e) => {
            if (
                (e.ctrlKey || e.metaKey) &&
                [65, 66, 67, 70, 73, 80, 83, 85, 86].includes(e.which)
            ) {
                e.preventDefault();
            }
            if (e.keyCode === 123 || e.keyCode === 18) {
                e.preventDefault();
            }
        };
    }, []);

    useEffect(() => {
        if (videoUrl.endsWith('.mp4')) {
            setVideoType('mp4');
        } else if (videoUrl.includes('segoma')) {
            setVideoType('segoma');
        } else {
            setVideoType('iframe');
        }
    }, [videoUrl]);

    return (
        <div className="iframe-container" onContextMenu={(e) => e.preventDefault()}>
            {videoType === 'mp4' ? (
                <video loop muted autoPlay width="100%" height="100%">
                    <source src={videoUrl.trim()} type="video/mp4" />
                    <source src="movie.ogg" type="video/ogg" />
                    Your browser does not support the video tag.
                </video>
            ) : (
                <iframe
                    src={videoUrl.trim()}
                    scrolling="no"
                    frameBorder="0"
                    title="Embedded Video"
                    allowFullScreen
                />
            )}
        </div>
    );
};

export default VideoPlayer;
